module.exports = __webpack_public_path__ + "static/media/date_1.950627b0.svg";